import React from 'react';
import { Tooltip } from 'antd';
import { PointOfSaleItem } from '../../model/pointofsale/PointOfSaleItem';
import { getItemTooltip } from '../../utils/posItemUtils';

interface PosItemNameCellProps {
  item: PointOfSaleItem;
  text: string;
}

/**
 * Component that renders an item name with a tooltip showing metadata (rank, transaction count)
 */
const PosItemNameCell: React.FC<PosItemNameCellProps> = ({ item, text }) => {
  const tooltip = getItemTooltip(item);
  
  if (tooltip) {
    return (
      <Tooltip title={tooltip}>
        <span style={{ cursor: 'help' }}>{text}</span>
      </Tooltip>
    );
  }
  
  return <>{text}</>;
};

export default PosItemNameCell;

